import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './shared/styles/globals.css';
import App from './app/App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';  
import store from './app/store/store';        

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

reportWebVitals();
